import React from 'react';
import { BASE_WORKSPACE_CAPABILITIES, workspaceFeatures } from '../lib/workspaceCapabilities';

export default function WorkspacePlanFields({ value, onChange }) {
  const c = { ...BASE_WORKSPACE_CAPABILITIES, ...value };
  const set = (patch) => onChange({ ...c, ...patch });
  const inputClass = 'mt-1 w-full rounded-lg border border-slate-200 bg-transparent px-3 py-2 text-sm';
  const number = (key, label, min = 0, max = 100) => <label className="block text-sm" key={key}>
    {label}<input className={inputClass} type="number" min={min} max={max} required value={c[key]}
      onChange={e => set({ [key]: e.target.value === '' ? '' : Number(e.target.value) })} />
  </label>;
  return <fieldset className="space-y-3 rounded-xl border border-blue-100 bg-blue-50/40 p-4">
    <legend className="px-1 text-sm font-semibold">Servicios: tableros y colaboración</legend>
    <label className="block text-sm">Familia del plan
      <select className={inputClass} value={c.tier} onChange={e => onChange(e.target.value === 'base' ? { ...BASE_WORKSPACE_CAPABILITIES } : { ...c, tier: 'pro' })}>
        <option value="base">Base</option><option value="pro">Pro</option>
      </select>
    </label>
    <label className="flex items-center gap-2 text-sm"><input type="checkbox" disabled={c.tier !== 'pro'} checked={c.multi_workspace_enabled}
      onChange={e => set({ multi_workspace_enabled: e.target.checked, max_owned_workspaces: e.target.checked ? 3 : 1,
        max_shared_workspaces: Math.min(c.max_shared_workspaces, e.target.checked ? 3 : 1) })} />Incluir varios tableros</label>
    {c.multi_workspace_enabled && number('max_owned_workspaces', 'Tableros propios (incluye Personal)', 1)}
    <label className="flex items-center gap-2 text-sm"><input type="checkbox" disabled={c.tier !== 'pro'} checked={c.sharing_enabled}
      onChange={e => set({ sharing_enabled: e.target.checked, max_shared_workspaces: e.target.checked ? 1 : 0,
        max_unique_guests: e.target.checked ? 3 : 0, max_guests_per_workspace: e.target.checked ? 3 : 0 })} />Incluir compartir tableros</label>
    {c.sharing_enabled && <>
      {number('max_shared_workspaces', 'Tableros compartidos simultáneamente', 1, c.max_owned_workspaces)}
      {number('max_unique_guests', 'Personas invitadas distintas en total', 1)}
      {number('max_guests_per_workspace', 'Invitados por tablero (no incluye al propietario)', 1, c.max_unique_guests)}
      <label className="block text-sm">Suscripción del invitado
        <select className={inputClass} value={c.guest_subscription_policy} onChange={e => set({ guest_subscription_policy: e.target.value })}>
          <option value="not_required">No exigir suscripción propia</option>
          <option value="active_paid">Exigir suscripción pagada activa</option>
        </select>
      </label>
      <p className="text-xs text-slate-600">La misma persona en varios tableros cuenta una sola vez en el total.</p>
    </>}
    <div className="rounded-lg bg-white p-3 text-xs text-slate-700"><strong>Así se mostrará el servicio</strong>
      <ul className="mt-2 list-disc space-y-1 pl-4">{workspaceFeatures({ workspace_capabilities: c }).map(label => <li key={label}>{label}</li>)}</ul>
    </div>
    <p className="text-xs text-slate-600">Estos permisos y cupos se aplican a todas las suscripciones vigentes de este plan, incluidas las anteriores al lanzamiento de tableros. Cambiarlos no modifica su fecha de vencimiento. Si reduces los cupos, el historial se conserva y los accesos que excedan el límite quedan restringidos.</p>
  </fieldset>;
}
